export default __webpack_public_path__ + "static/media/dailymotion_white.c5dc9b9c.svg";